module.exports = __webpack_public_path__ + "img/Turkmenistan.f39ce2da.svg";